import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';
import type { OrganizationType } from '@/types/session';

export const Route = createFileRoute('/$')({
  component: CatchAllRedirect,
});

function getDefaultRoute(orgType: OrganizationType, userType: string | null): string {
  if (userType === 'EMPLOYEE') return '/e';

  switch (orgType) {
    case 'WORKPAY':
      return '/w/dashboard';
    case 'TENANT':
      return '/t/employees';
    case 'PARTNER':
      return '/p';
  }
}

function CatchAllRedirect() {
  const navigate = useNavigate();
  const organizationType = useAuthStore((s) => s.organizationType);
  const userType = useAuthStore((s) => s.userType);

  useEffect(() => {
    if (organizationType) {
      void navigate({ to: getDefaultRoute(organizationType, userType), replace: true });
    }
  }, [organizationType, userType, navigate]);

  return null;
}
